import React, { useMemo } from 'react';
import { useMatch } from 'react-router-dom';

import { useNavigateWithParams } from 'hooks/useNavigateWithParams';
import { useMemberGroupData } from 'hooks/useMemberGroupData';

import { GroupLearnings } from 'components/layout/GroupLearnings';
import { RetroList } from 'components/layout/RetroList';
import { ValuesList } from 'components/layout/ValuesList';

import { Tab, TabControls } from 'components/ui/TabControls';

import Telescope from 'assets/telescope.png';
import Birds from 'assets/birds.png';

import { colors, Fonts, spacing, transparencies } from 'styles/theme';
import { Card, ContentScroller, Bumper, BannerWrapper } from 'styles/shared';

interface InsightsProps {
    isPursuit?: boolean;
}

export const Insights = ({ isPursuit = false }: InsightsProps) => {
    const navigateWithParams = useNavigateWithParams();
    const { closings, sessionDetails } = useMemberGroupData();

    const baseRoute = isPursuit ? 'pursuit' : 'member';

    const groupLearningsRoute = useMatch(
        `/${baseRoute}/insights/group-learnings/*`
    );
    const retroRoute = useMatch(`/${baseRoute}/insights/grand-retro/*`);
    const valuesRoute = useMatch(`/${baseRoute}/insights/values/*`);

    const insightsTabs: Array<Tab> = useMemo(
        () => [
            {
                text: `${isPursuit ? '' : 'Group '}Learnings`,
                isSelected: groupLearningsRoute != null,
                onClick: () =>
                    navigateWithParams(
                        `/${baseRoute}/insights/group-learnings`
                    ),
            },
            {
                text: 'The Grand Retro',
                isSelected: retroRoute != null,
                onClick: () =>
                    navigateWithParams(`/${baseRoute}/insights/grand-retro`),
            },
            {
                text: 'My Values',
                isSelected: valuesRoute != null,
                onClick: () =>
                    navigateWithParams(`/${baseRoute}/insights/values`),
            },
        ],
        [
            retroRoute,
            isPursuit,
            navigateWithParams,
            baseRoute,
            groupLearningsRoute,
            valuesRoute,
        ]
    );

    return (
        <ContentScroller>
            <Bumper $minHeight={spacing.xxxLarge} $shouldHideOnMobile />
            <Bumper $minHeight={spacing.xxxLarge} $shouldHideOnMobile />
            <Bumper $minHeight={spacing.xxSmall} $shouldHideOnDesktop />
            <Card
                $backgroundColor={
                    isPursuit ? transparencies.white95 : colors.white
                }
            >
                <BannerWrapper
                    $backgroundImageUrl={
                        groupLearningsRoute != null ? Telescope : Birds
                    }
                >
                    <Fonts.Heading5>{`Insights`}</Fonts.Heading5>
                </BannerWrapper>
                <Bumper $minHeight={spacing.xxxLarge} />
                <TabControls tabs={insightsTabs} />
                <Bumper
                    $minHeight={
                        retroRoute == null && valuesRoute == null
                            ? spacing.xLarge
                            : spacing.xxSmall
                    }
                />
                {groupLearningsRoute == null ? null : (
                    <GroupLearnings
                        closings={closings}
                        sessionDetails={sessionDetails}
                    />
                )}
                {retroRoute == null ? null : <RetroList />}
                {valuesRoute == null ? null : <ValuesList />}
            </Card>
            <Bumper $minHeight={spacing.xxxLarge} />
        </ContentScroller>
    );
};
